import { keyframes } from "styled-components";

export const dotsLoader = keyframes`
    0% {
      content: ".";
    }
    33% {
      content: ". .";
    }
    66% {
      content: ". . .";
    }
    100% {
      content: ".";
    }
`;

export const dotsLoaderWidthAnimated = keyframes`
  0% { width: 0; }
  33% { width: 0.35em; }
  66% { width: 0.7em; }
  100% { width: 1.05em; }
`;
